<template>
	<div ref="container"></div>
</template>

<script>
import WordCloudWidget from '@/widgets/WordCloudWidget';

const SAMPLE_WORDS = [
	'stream', 'hello', 'PogChamp', 'hype', 'love', 'chat', 'follow', 'subscribe',
	'Kappa', 'awesome', 'thanks', 'gg', 'lol', 'clip', 'raid', 'game', 'pog', 'wow',
	'monka', 'win', 'haha', 'nice', 'based', 'copium', 'sadge', 'pepe', 'clap',
	'lurk', 'vibe', 'hype', 'goat', 'based', 'noice', 'ez', 'rip', 'bruh', 'lets',
	'go', 'poggers', 'pepehands', 'dansgame', 'jebaited', 'kreygasm', 'trihard',
	'4head', 'biblethump', 'notlikethis', 'residentsleeper', 'omegalul', 'lulw',
	'monkas', 'widepeeposad', 'feelsweakman', 'catjam', 'sumsmash', 'donowall',
	'prime', 'bits', 'cheer', 'goal', 'alert', 'timer', 'emote', 'badge', 'rank',
	'first', 'banger', 'clip', 'pogU', 'ready', 'hug', 'yes', 'no', 'maybe', 'soon',
	'100', 'W', 'L', 'real', 'fake', 'true', 'false', 'good', 'bad', 'best', 'worst',
	'play', 'pause', 'stop', 'start', 'restart', 'reset', 'lag', 'fps', 'smooth',
	'fire', 'ice', 'wild', 'crazy', 'insane', 'skill', 'clutch', 'carry', 'feed',
	'bot', 'flex', 'meta', 'patch', 'nerf', 'buff', 'ranked', 'casual', 'tournament',
].map((word, i, arr) => ({ word, n: arr.length - i }));

export default {
	name: 'WordCloudWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
		realData: { type: Boolean, default: false },
	},
	data() {
		return {};
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
		realData() { this._destroyWidget(); this._initWidget(); },
	},
	mounted() {
		this._initWidget();
	},
	beforeDestroy() {
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			let words = SAMPLE_WORDS;

			if(this.realData) {
				try {
					const user = await this.$api.get('userData');
					const hash = user?.widget_hash || 'preview';
					const raw = await this.$api.get(`widget/${encodeURIComponent(hash)}/words`).catch(() => null);
					if(raw) words = raw;

					this._previewSubId = this.$socket.subscribe('preview', { reconnect: () => this._destroyWidget() || this._initWidget() });

					this._scheduleWordRefresh(hash);
				} catch(e) { /* ignore */ }
			}

			this.widget = new WordCloudWidget({
				container: this.$refs.container,
			});

			const baseCSSElem = document.getElementById('wordCloudBaseCSS');
			if(baseCSSElem) {
				baseCSSElem.textContent = baseCSSElem.textContent
					.replace(/(?:html|body)(?:\s*,\s*(?:html|body))?\s*\{[^}]*\}/g, '');
			}

			await this.widget.init({ settings: { ...this.settings }, words });
		},
		_scheduleWordRefresh(hash) {
			clearTimeout(this._wordRefreshTimer);
			const ms = (this.widget?.settings?.refreshInterval || 10) * 60 * 1000;
			this._wordRefreshTimer = setTimeout(async () => {
				const raw = await this.$api.get(`widget/${encodeURIComponent(hash)}/words`).catch(() => null);
				if(raw && this.widget) this.widget.applyWords(raw);
				this._scheduleWordRefresh(hash);
			}, ms);
		},
		_destroyWidget() {
			clearTimeout(this._wordRefreshTimer);
			this._wordRefreshTimer = null;
			if(this._previewSubId != null) { this.$socket.unsubscribe(this._previewSubId); this._previewSubId = null; }
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
	},
};
</script>
